import { createColumnHelper } from '@tanstack/react-table'
import { DeviceAlertRow } from '../../types/DeviceTypes'
import alertResolved from '../../assets/alert-resolved.png'
import alertUnresolved from '../../assets/alert-unresolved.png'
import { capitalize } from '../../utils/capitalize'
import { formatUtcTimestamp } from '../../utils/dates'
import { Button } from '@radix-ui/themes'

export const deviceAlertColumns = (getAlertDetails: (alert: DeviceAlertRow) => void) => {
  const columnHelper = createColumnHelper<DeviceAlertRow>()

  return [
    columnHelper.accessor('alertName', {
      header: 'Name',
      enableSorting: true,
    }),
    columnHelper.accessor('severity', {
      header: 'Severity',
      cell: (info) => generateSeverity(info.getValue()),
      enableSorting: true,
    }),
    columnHelper.accessor('alertStatus', {
      id: 'alertStatus',
      header: 'Status',
      cell: (info) => generateAlertPill(info.getValue()),
      enableSorting: true,
    }),
    columnHelper.accessor('lastSeen', {
      header: 'Last Seen (UTC)',
      cell: (info) => formatUtcTimestamp(info.getValue()),
      enableSorting: true,
    }),
    {
      id: 'button',
      cell: (row: { row: { original: DeviceAlertRow } }) => (
        <Button
          size={'2'}
          className="cursor-pointer float-right"
          onClick={() => {
            getAlertDetails(row.row.original)
          }}
          variant="outline"
        >
          View
        </Button>
      ),
    },
  ]
}

export const generateAlertPill = (alertCreated: string) => {
  switch (alertCreated) {
    case 'OPEN':
      return (
        <div className="flex">
          <img src={alertUnresolved} alt="Alert Unresolved" className="h-5 w-5 mr-1.5" />
          <p className="text-mainText text-sm font-medium">Unresolved</p>
        </div>
      )
    case 'CLOSED':
      return (
        <div className="flex">
          <img src={alertResolved} alt="Alert Resolved" className="h-5 w-5 mr-1.5" />
          <p className="text-mainText text-sm font-medium">Resolved</p>
        </div>
      )
  }
}

export const generateSeverity = (severity: string) => {
  return <p className="capitalize">{capitalize(severity)}</p>
}
